import { render, staticRenderFns } from "./historyTrans.vue?vue&type=template&id=340bec72"
import script from "./historyTrans.vue?vue&type=script&lang=js"
export * from "./historyTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports